import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PanelComponent } from '@libs/front/components/panel/panel.component';

/**
 * Left "Holes legend" card shared by the State / Geology / Quality views.
 * Wraps the kit panel with the tab's title; views project their legend content.
 * Design source : Figma 2544:670266 ("general information")
 */
@Component({
  selector:        'app-holes-legend-panel',
  standalone:      true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports:         [PanelComponent, TranslateModule],
  template: `
    <app-panel [title]="'HOLES_TAB.HOLES_LEGEND' | translate">
      <ng-content />
    </app-panel>
  `,
  styles: [`
    :host {
      display:    flex;
      width:      100%;
      height:     100%;
      min-height: 0;
    }
  `],
})
export class HolesLegendPanelComponent {}
